module.exports = __webpack_public_path__ + "img/data-availability-3.199c87d9.jpg";